import React from 'react'
import calderas from '../../images/CALDERASIN.png'
import bullets from '../../images/BULLETS_LLAVE_EN_MANO.png'
import { itemsHomeCaldera } from '../../utils/itemsHomeCaldera'
import ItemHomeSelection from './ItemHomeSelection'

export default function ImageBootomHome() {
    return (

        <div className="items_selection_home">
            <div className="items_selection_home_left">
                <img src={calderas} alt="" className="caldera_left" />
                <img src={bullets} alt="" className="bullets_left" />
            </div>
            <div className="items_selection_home_right">
                {itemsHomeCaldera.map((item) =>
                    <ItemHomeSelection
                        key={item.index}
                        index={item.index}
                        text={item.text} />
                )}
            </div>
        </div>
    )
}
